import { render, staticRenderFns } from "./IrisSelectableTile.vue?vue&type=template&id=6b622768&"
import script from "./IrisSelectableTile.vue?vue&type=script&lang=ts&"
export * from "./IrisSelectableTile.vue?vue&type=script&lang=ts&"
import style0 from "./IrisSelectableTile.vue?vue&type=style&index=0&id=6b622768&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports